import { Component, Input, Inject, OnDestroy } from "@angular/core";
import { HttpService } from "../../providers/http.service";
import { ENV } from "../../environments/environment-variables.token";
import { Router, NavigationEnd } from "@angular/router";
// import * as moment from 'moment';
/**
 * Generated class for the DefaultTable component.
 *
 *
 */

@Component({
	selector: "default-header",
	templateUrl: "default-header.html",
	styleUrls: ["./default-header.scss"],
	providers: [],
})
export class DefaultHeaderComponent implements OnDestroy {

	/*
		- TODO:
			- CREATE SEARCH FUNCTIONALITY
			- CREATE TABLE TEMPLATE
			- CALLBACK FOR CHANGES ON PAGINATION

			options: {
				provider: // Server url for filter and list,
				headers: // Table headers for orderBy {"text","value"}
				template: // html template for form itens (users tableItens var for loop),
				perPage: //itens per page
			}
	*/
	public username: any;
	public institution: any;
	institutionColor: any;
	mySubscription: any;
	@Input() title: any;
	constructor(
		private httpService: HttpService,
		private router: Router,
		@Inject(ENV) public ENV: any
	) {
		console.log("Hello DefaultTableComponent Component");
		const hasInstitution = localStorage.getItem("institution");
		// console.log('TA NULO?????  ', hasInstitution)
		if (this.ENV.USER && this.ENV.USER.name) {
			this.username = this.ENV.USER.name;
		}

		this.router.routeReuseStrategy.shouldReuseRoute = () => {
			return false;
		};

		this.mySubscription = this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.router.navigated = false;
			}
		});

		if (localStorage.getItem("institution")) {

			const instituitionSession = JSON.parse(localStorage.getItem("institution"));
			// console.log("iiiiiiiiiiiiii", instituitionSession)
			const color = instituitionSession.color;
			this.ENV.INSTITUTION_COLOR = instituitionSession.color;
			// console.log("coooooooooor", color);
			// console.log("info", instituitionSession);
			this.ENV.INSTITUTION_NAME = instituitionSession.title;
			// console.log("institutionsession", instituitionSession);
			this.institution = instituitionSession.institution_title;
			if (this.ENV.INSTITUTION_COLOR) {
				if (this.ENV.INSTITUTION_COLOR === "") {
					this.ENV.INSTITUTION_COLOR = "#282B34";
				}
			} else {
				this.ENV.INSTITUTION_COLOR = "#282B34";
			}
		} else {
			this.ENV.INSTITUTION_COLOR = "#282B34";
		}
		console.log("ENV", this.ENV);
	}

	ngOnDestroy() {
		if (this.mySubscription) {
			this.mySubscription.unsubscribe();
		}
	}

	toggle() {
		this.ENV.toggleMenu = !this.ENV.toggleMenu;
    this.ENV.headerWidth = document.querySelector(".day-header")["offsetWidth"];

    let i = 0;
    while(i < 10) {
      setTimeout(() => {
        this.ENV.headerWidth = document.querySelector(".day-header")["offsetWidth"];
      }, 50);
      i++;
    }
		console.log("this.ENV.toggleMenu", this.ENV.toggleMenu);
	}

	getImage() {
		const img = this.ENV.USER;
		if (!img) { return "./assets/imgs/no-avatar.png"; }
		return img.picture && img.picture.host ? img.picture.host + img.picture.thumb : "./assets/imgs/no-avatar.png";
	}
	createInstituition() {
		this.router.navigateByUrl("pages/createinstitution");
	}
}
